module.exports = __webpack_public_path__ + "img/DST 2001 member.92b574f7.png";